import { Box, Typography } from "@mui/material";
import React from "react";

export const CustomLegend = (props) => {
    let { data, dataKey = "value", setData = () => { } } = props;
    const total = data.filter((item) => item.active).reduce((sum, entry) => sum + entry[dataKey], 0);
    return (
        <Box
            className="custom-legend"
            style={{ justifyContent: "center" }}
        >
            {data.map((entry, index) => {
                const percentage = entry.active && total ? ((entry[dataKey] / total) * 100).toFixed(2) : 0;
                return (
                    <Box key={index} display="flex" alignItems="center" mb={1}
                        style={{ cursor: "pointer", opacity: entry.active ? 1 : 0.5 }}
                        onClick={() => {
                            setData((prevData) =>
                                prevData.map((item, i) =>
                                    i === index ? { ...item, active: !item.active } : item
                                )
                            );
                        }}>
                        <Box
                            sx={{
                                width: 12,
                                height: 12,
                                backgroundColor: entry.color,
                                borderRadius: "50%",
                                mr: 1,
                                flexShrink: 0
                            }}
                        />
                        <Typography
                            variant="p"
                            sx={{ fontSize: "13px", fontWeight: 600 }}
                        >
                            {`${entry.name}: ${percentage}%`}
                        </Typography>
                    </Box>
                )
            })}
        </Box>
    );
};
const canvas = document.createElement("canvas");
const ctx = canvas.getContext("2d");

const truncateByWidth = (text, maxWidth, font = "12px sans-serif") => {
  ctx.font = font;

  if (ctx.measureText(text).width <= maxWidth) return text;

  let truncated = text;
  while (ctx.measureText(truncated + "…").width > maxWidth && truncated.length > 0) {
    truncated = truncated.slice(0, -1);
  }
  return truncated + "…";
};

export const BarChartLegend = (props) => {
  let { data, setData } = props
  return (
    <Box className="bar-chart-legend" style={{ justifyContent: 'center' }}>
      {data.map((entry, index) => (
        <Box
          key={index}
          display="flex"
          alignItems="center"
          mb={1}
          style={{ cursor: 'pointer', opacity: entry.active ? 1 : 0.5 }}
          onClick={() => {
            setData((prevData) => prevData.map((item, i) => (i === index ? { ...item, active: !item.active } : item)))
          }}
        >
          <Box
            sx={{
              width: 12,
              height: 12,
              backgroundColor: entry.color,
              borderRadius: '50%',
              mr: 1,
              flexShrink: 0,
            }}
          />
          <Typography variant="p" sx={{ fontSize: '13px', fontWeight: 600 }}>
            {entry.name}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}

export const renderCustomizedLabel = (props) => {
    const { cx, cy, midAngle, innerRadius, outerRadius, percent,name } = props;
    // console.log(props)
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) / 2;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const labelInsideThreshold = 0.1;
    const isLabelInside = percent > labelInsideThreshold;
    const color = '#444444'
    if (isLabelInside) {
        return (
            <text
                x={x}
                y={y}
                fill="white"
                textAnchor="middle"
                dominantBaseline="central"
                fontSize={12}
                fontWeight="bold"
            >
                {`${name} ${(percent * 100).toFixed(0)}%`}
            </text>
        );
    } else {
        // Label outside slice
        const outsideRadius = outerRadius + 20; // position outside slice
        const xOutside = cx + outsideRadius * Math.cos(-midAngle * RADIAN);
        const yOutside = cy + outsideRadius * Math.sin(-midAngle * RADIAN);

        // Line from slice edge to label
        const lineX = cx + outerRadius * Math.cos(-midAngle * RADIAN);
        const lineY = cy + outerRadius * Math.sin(-midAngle * RADIAN);
        return (
            <g>
                <polyline
                    points={`${lineX},${lineY} ${xOutside},${yOutside}`}
                    stroke={color}
                    fill="none"
                />
                <text
                    x={xOutside}
                    y={yOutside}
                    fill={color}
                    textAnchor={xOutside > cx ? 'start' : 'end'}
                    dominantBaseline="central"
                    fontSize={12}
                    fontWeight="bold"
                >
                    {`${name} ${(percent * 100).toFixed(0)}%`}
                </text>
            </g>
        );
    }
};
const EllipsisTick = ({ x, y, payload, textAnchor = "end", angle = 0, maxWidth = 80 }) => {
    const label = payload.value;
    const truncatedLabel = truncateByWidth(label, maxWidth, "12px sans-serif");
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          transform={`rotate(${angle})`}
          x={0}
          y={0}
          dy={16}
          textAnchor={textAnchor}
          fill="#666"
          style={{
            maxWidth,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontSize: "12px"
          }}
        >
          {truncatedLabel}
        </text>
      </g>
    );
  };
  
  export const createEllipsisTick = (angle, textAnchor = "end", maxWidth = 80) => (props) =>
    <EllipsisTick {...props} angle={angle} textAnchor={textAnchor} maxWidth={maxWidth} />;